export default function getEnvironment() {
  const isWindow = typeof window !== 'undefined';
  const userAgent = window.navigator.userAgent.toLocaleLowerCase();
  const isSuperAcme = typeof window.SuperAcme !== 'undefined' || userAgent.includes('superacme');

  return {
    isWindow,
    isSuperAcme,
    isNative:
      userAgent.includes('ios') || userAgent.includes('iphone') || userAgent.includes('android'),
    isIOS: userAgent.includes('ios') || userAgent.includes('iphone') || userAgent.includes('ipad'),
    isAndroid: userAgent.includes('android'),
  };
}

export const isIOS = getEnvironment().isIOS;
export const isAndroid = getEnvironment().isAndroid;
export const isNative = getEnvironment().isNative;
export const isSuperAcme = getEnvironment().isSuperAcme;
export const isWindow = getEnvironment().isWindow;
export const isWebView = isIOS || isAndroid;
